import { FC, useState } from "react";
import { toast } from "react-hot-toast";
import { ICustomTripWorkingDayPattern } from "../../../interfaces/endpoints/patterns/ICustomTripWorkingDayPattern";
import { CustomTripWorkingDayType } from "../../../interfaces/endpoints/trips/Trips.types";
import { upsertPattern } from "../../../services/CustomTripWorkingDayPattern.service";
import Button from "../../ui/Button";
import Input from "../../ui/input/Input";
import Modal from "../../ui/Modal";
import { SpinLoader } from "../../ui/SpinLoader";

interface SavePatternModalProps {
  show: boolean;
  onClose: () => void;
  selectedDates: { date: Date }[];
  workingDaysType: CustomTripWorkingDayType;
  onPatternCreated?: () => void;
}

const SavePatternModal: FC<SavePatternModalProps> = ({
  show,
  onClose,
  selectedDates,
  workingDaysType,
  onPatternCreated
}) => {
  const [name, setName] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSave = async () => {
    if (!name.trim()) {
      toast.error("Emri i kalendar-it është i detyrueshëm");
      return;
    }

    if (!selectedDates.length) {
      toast.error("Ju lutem zgjidhni së paku një datë");
      return;
    }

    setIsSubmitting(true);
    try {
      const pattern: ICustomTripWorkingDayPattern = {
        name: name.trim(),
        type: workingDaysType,
        dates: selectedDates.map((d) => ({
          date: new Date(Date.UTC(
            d.date.getFullYear(),
            d.date.getMonth(),
            d.date.getDate(),
            12, 0, 0, 0
          ))
        }))
      };

      await upsertPattern(pattern);
      toast.success("Pattern-i u ruajt me sukses");
      onPatternCreated?.();
      onClose();
    } catch (error) {
      toast.error("Ndodhi një gabim gjatë ruajtjes së pattern-it");
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <Modal
      show={show}
      onClose={onClose}
      position="center"
      title="Emërto kalendarin"
      modalWidth="400px"
      buttonElement={
        <Button
          btnType="primary"
          className="flex items-center justify-center min-w-[100px]"
          onClick={handleSave}
          disabled={isSubmitting}
        >
          {isSubmitting ? (
            <SpinLoader formatClassName="w-4 h-4" />
          ) : (
            "Ruaj"
          )}
        </Button>
      }
    >
      <div className="p-4">
        <Input
          label="Emri i kalendar-it*"
          placeholder="Shkruani emrin"
          value={name}
          onChange={(e) => setName(e.target.value)}
        />
      </div>
    </Modal>
  );
};

export default SavePatternModal;
